import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      d="M3 6v12h20V6H3Zm4 10c0-1.1-.9-2-2-2v-4c1.1 0 2-.9 2-2h12c0 1.1.9 2 2 2v4c-1.1 0-2 .9-2 2H7Z"
    />
    <path
      fill="#A5A5AA"
      d="M13 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
);
export default SvgCash;
